// extracted by mini-css-extract-plugin
export default {"actionBtn":"Modify_actionBtn__lMeEP","confirm":"Modify_confirm__Y2Mz0","reject":"Modify_reject__R+GPU"};